import React from "react";

const textualStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "8px",
  background: "var(--color-surface-1)",
  border: "1px solid rgba(255, 255, 255, 0.05)",
  lineHeight: "1.9",
  color: "var(--color-text-secondary)",
};

const ReturnPolicy = () => {
  return (
    <div style={textualStyle}>
      <h2
        style={{
          color: "var(--color-text-primary)",
          marginBottom: "15px",
          borderBottom: "1px solid var(--color-border-light, rgba(255,255,255,0.1))",
          paddingBottom: "15px",
        }}
      >
        Returns & Exchanges Policy
      </h2>

      <p
        style={{
          color: "#f97316",
          fontStyle: "italic",
          fontSize: "1.1rem",
          marginBottom: "30px",
        }}
      >
        At Regard Traders, we want your stock to be absolutely flawless.
      </p>

      <p>
        To keep our B2B partnership smooth and transparent, we handle damages,
        defects, or missing items through a straightforward process designed to
        resolve issues quickly while maintaining fairness for all parties.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        1. 12-Hour Reporting Window
      </h3>

      <p>
        Please inspect your shipment immediately upon arrival and notify us via
        WhatsApp within <strong>12 hours of delivery</strong> if any item is
        damaged, missing, or contains a manufacturing defect. Prompt reporting
        allows us to raise claims with our logistics and transit partners
        without delay.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        2. Unboxing Video Requirement
      </h3>

      <p>
        To ensure a fast and transparent claim process, a continuous unboxing
        video is mandatory. The video must clearly display the shipping label
        before opening the package and continue without interruption until all
        products are visible.
      </p>

      <p>
        This requirement helps eliminate ambiguity, verifies product condition
        upon delivery, and significantly speeds up claim approvals.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        3. Store Credit or Replacement Policy
      </h3>

      <p>
        As a wholesale supplier, Regard Traders does not provide cash refunds.
        Once a claim has been reviewed and approved, we will provide one of the
        following resolutions:
      </p>

      <ul style={{ paddingLeft: "25px" }}>
        <li>Replacement products with your next order, or</li>
        <li>
          Equivalent store credit that can be used toward future purchases.
        </li>
      </ul>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        4. Non-Returnable Products
      </h3>

      <p>
        For hygiene, safety, and quality-control reasons, the following items
        are not eligible for returns, exchanges, replacements, or store credit:
      </p>

      <ul style={{ paddingLeft: "25px" }}>
        <li>Opened or used cosmetic products</li>
        <li>Products with damaged packaging due to customer handling</li>
        <li>Fashion items with removed retail tags</li>
        <li>Products reported after the 12-hour claim window</li>
      </ul>

      <p
        style={{
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid var(--color-border-light, rgba(255,255,255,0.1))",
          fontStyle: "italic",
          color: "var(--color-text-secondary, #d4d4d8)",
        }}
      >
        By placing an order with Regard Traders, you acknowledge and agree to
        the terms outlined in this Returns & Exchanges Policy.
      </p>
    </div>
  );
};

export default ReturnPolicy;